var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31827 1.71999C3.35044 0.735279 1.76758 0.721596 0.782871 1.68943C-0.201844 2.65726 -0.215528 4.24012 0.752307 5.22483L13.3588 18.0512L0.74719 30.9562C-0.217835 31.9436 -0.199643 33.5264 0.787824 34.4915C1.77529 35.4565 3.3581 35.4383 4.32312 34.4508L16.8644 21.6179L29.2475 34.217C30.2153 35.2017 31.7982 35.2154 32.7829 34.2475C33.7676 33.2797 33.7813 31.6968 32.8134 30.7121L20.3598 18.0413L32.8285 5.28259C33.7935 4.29512 33.7753 2.71231 32.7879 1.74729C31.8004 0.782262 30.2176 0.800455 29.2526 1.78792L16.8542 14.4746L4.31827 1.71999Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.5dde470134dc7f9197c72d25f4e2ec8e.svg";
export { ForwardRef as ReactComponent };